import PageStyle from "../../../Components/Layout/PageLayout";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import { useNavigate } from "react-router";
import Pagination from "../../../Components/Pagination/Pagination";
import Table from "../../../Components/Table/Table";
import { TableActions } from "../../../Components/Misc/Actions";
import { CalendarFilter2, ProDropFilter, SearchFilter } from "../../../Components/Search/Search";
import { useSearchFilter } from "../../../../../utils/functions/useDate";
import { useGetAllRetirementQuery } from "../../../../api/financeApi";
import { FormatDateTime } from "../../../../../utils/functions/ResourceFunctions";
import { FilterByStatus } from "../FloatRequest/data";
import { useState } from "react";


const FloatInternalControlReview = () => {
  const {
    searchText,
    setSearchText,
    pageSize,
    setPageSize,
    setCurrentPage,
    currentPage,
    filter,
    setFilter,
  } = useSearchFilter({
    initialFilter: 1,
  });
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const { data, isLoading } = useGetAllRetirementQuery({
    pageSize: pageSize,
    pageNumber: currentPage,
    searchText,
    filter,
    startDate,
    endDate,
  });
  const navigate = useNavigate();
  const handleView = (id) => {
    if (id) {
      navigate(`${id}/view-float-control-review`);
    }
  };
  const tableContent = isLoading ? (
    <tr>
      <td colSpan={6} className="text-center">
        Loading...
      </td>
    </tr>
  ) : data?.result?.length > 0 ? (
    data?.result?.map((item, index) => {
      return (
        <tr key={index}>
          <td>{index + 1}</td>
          <td>{item?.requester}</td>
          <td>{parseInt(item?.floatTypeName) === 1 ? "Relationship Management" : "Business Development"}</td>
          <td>₦{item?.approvedAmount?.toLocaleString()}</td>
          <td>₦{item?.amountPayable?.toLocaleString()}</td>
          <td>{FormatDateTime(item?.retirementDate)}</td>
          <td>{item?.approvalStatusName}</td>
          <td>{FormatDateTime(item?.retirementDate)}</td>
          <td>{item?.approvalStatusName}</td>
          <td>
            <TableActions hasChildren={true} url={`${item.id}/view-float-control-review`}>
              {[

                {
                  name: "View",
                  action: () => handleView(item.id),
                },
              ]}
            </TableActions>
          </td>
        </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan={6} className="text-center">
        No Status Label Found
      </td>
    </tr>
  );
  return (
    <PageStyle
      hasBack={false}
      demoTitle={"EMPLOYEE FLOAT REQUEST"}
      hasTopPageDemo
    >
      <div className="flex justify-between items-center">
        <form className={DashboardStyle.dashboard_filter}>
          <SearchFilter
            value={searchText}
            text={(searchText) => setSearchText(searchText)}
          />
          <CalendarFilter2
            name="Select Date Range"
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            normalDate
          />
          <ProDropFilter
            filter={filter}
            setFilter={setFilter}
            name={"Status"}
            filterBy={FilterByStatus}
          />
        </form>
      </div>
      <Table>
        <thead>
          <tr>
            <th>S/N</th>
            <th>Requestor Name</th>
            <th>Purpose</th>
            <th>Amount Advanced</th>
            <th>Payment Date</th>
            <th>Due Date</th>
            <th>Retirement Status</th>
            <th>Retirement Deadline</th>
            <th>Approval Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {tableContent}
        </tbody>
      </Table>
      <Pagination
        currentPage={currentPage}
        pageSize={pageSize}
        totalCount={data?.responseObject?.totalCount}
        onPageChange={setCurrentPage}
        onPageSizeChange={setPageSize}
      />
    </PageStyle>
  );
}

export { FloatInternalControlReview };